import React from 'react';
import styled from '@emotion/styled';
import WarningIcon from 'ui/images/icons/warning.svg';

const NoticeWrapper = styled.div`
    display: flex;
    flex-direction: column;
    padding: 12px;
    background-color: #fff3e0;
    border: 3px solid #ffb74d;
    border-radius: 6px;
    margin: 10px 0;
`;

const Row = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

const Icon = styled.img`
    width: 20px;
    height: 20px;
    flex-shrink: 0;
`;

const Title = styled.div`
    font-size: 15px;
    font-weight: 700;
    color: #e65100;
`;

const Text = styled.div`
    font-size: 14px;
    font-weight: 600;
    color: #e65100;
    line-height: 1.5;
    text-align: left;
    margin-top: 2px;
`;

export const CompanyInfoVisibilityNotice: React.FC<{ userType?: string }> = ({ userType }) => {
    return (
        <NoticeWrapper>
            <Row>
                <Icon src={WarningIcon} alt="警告" />
                <Title>ご注意ください</Title>
            </Row>
            <Text>
                {userType === 'buyer' && 'その他希望事項等、'}
                事業内容（自由記述）、仲介会社に聞いてみたいこと欄は、マッチング前の仲介会社からも閲覧可能です。
                「会社名」「会社HP」など、会社が特定される可能性のある情報を記載しないようご注意ください。
            </Text>
        </NoticeWrapper>
    );
};
